<template>
  <div class="employee-debtors-sms-view">

    <div class="employee-debtors-sms-view__col">
      <app-panel title="Отправка смс" class="employee-debtors-sms">
        <div class="employee-debtors-sms__row employee-debtors-sms__row_center">
          <div class="employee-debtors-sms__file" :class="{'employee-debtors-sms__file_danger': errors.file}">
            <label class="employee-debtors-sms__file-label">Файл</label>
            <vs-upload
                    action="#"
                    :limit="1"
                    :show-upload-button="false"
                    :multiple="false"
                    text="Добавить файл"
                    @change="addFile"
                    @on-delete="resetFile"
                    ref="fileUploader"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
            <div class="employee-debtors-sms__file-error">
              Добавьте файл
            </div>
          </div>
        </div>
        <div class="employee-debtors-sms__row">
          <app-textarea label="Текст сообщения" v-model="sms_text" :danger.sync="errors.text"
                        danger-text="Введите текст сообщения" height="150px"/>
        </div>
        <div class="employee-debtors-sms__row employee-debtors-sms__row_center">
          <app-button color="success" @click="sendData" :disabled="isSending">{{isSending ? 'Отправляю' : 'Отправить'}}
          </app-button>
        </div>
      </app-panel>
    </div>

    <div class="employee-debtors-sms-view__col">
      <send-history ref="sendHistoryPanel"/>
    </div>

    <sms-answer ref="smsAnswer"/>
  </div>
</template>

<script>
  import SmsAnswer from "@/components/debtors/sms/SmsAnswer";
  import SendHistory from "@/components/debtors/sms/SendHistory";

  export default {
    name: "SendSms",
    components: {
      SmsAnswer,
      SendHistory
    },
    data() {
      return {
        isResultOpen: false,
        isSending: false,
        sms_text: "",
        file: null,
        errors: {
          text: false,
          file: false,
        }
      }
    },
    computed: {
      selectedHouseId() {
        return this.$store.getters['appUser/selectedHouse'].id;
      },
      hasError() {
        for (let errorIndex in this.errors) {
          if (this.errors.hasOwnProperty(errorIndex) && this.errors[errorIndex]) {
            return true
          }
        }
        return false;
      }
    },
    methods: {
      resetText() {
        this.sms_text = "";
        this.errors.text = false;
      },
      resetFile() {
        this.file = null;
        this.errors.file = false;
      },
      addFile(e, files) {
        this.file = files.filter(file => !file.remove)[0];
        this.errors.file = false;
      },
      checkTextForError() {
        if (this.sms_text === null || !this.sms_text.length) {
          this.errors.text = true;
        }
      },
      checkFileForError() {
        if (!this.file) {
          this.errors.file = true;
        }
      },
      async sendData() {
        if (this.isSending) return false;


        this.checkTextForError();
        this.checkFileForError();

        if (!this.hasError) {
          this.isSending = true;
          try {
            let body = {
              buildings_id: this.selectedHouseId,
              sms_text: this.sms_text,
              file: this.file
            };

            let bodyFormData = new FormData();

            for (let key in body) {
              if (body.hasOwnProperty(key)) {
                if (Array.isArray(body[key])) {
                  for (let i = 0; i < body[key].length; i++) {
                    bodyFormData.append(`${key}[${i}]`, body[key][i]);
                  }
                } else {
                  bodyFormData.append(key, body[key])
                }
              }
            }

            let {data} = await this.$http.post('sms/send_file', bodyFormData, {
              headers: {
                'Content-Type': 'multipart/form-data;'
              }
            });

            if (data === "error") {
              this.$vs.notify({color: 'danger', title: 'Произошла ошибка', text: 'Отправка не удалась'});
            } else if (data === "file already uploaded") {
              this.$vs.notify({color: 'danger', title: 'Отправка не удалась', text: 'Данный файл уже был загружен'});
            } else {
              this.$refs.smsAnswer.open(data.sent);
              this.$refs.SendHistoryPanel.updateData();
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status === 403) {
                this.$vs.notify({color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав'});
              } else {
                this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже'});
              }
            } else {
              this.$vs.notify({color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка'});
            }
          } finally {
            this.isSending = false;
          }
        }
      },
    },
    created() {
      this.resetText();
    },
  }
</script>

<style lang="scss">
  .employee-debtors-sms {
    height: 100%;
    &__file {
      display: inline-block;

      &-label {
        color: #627084;
        font-size: 1rem;
        margin-bottom: 2px;
        display: block;
      }

      .con-img-upload {
        padding: 0;
        margin: 0;

        .img-upload {
          margin: 0;
          border: 1px solid #eee;
        }
      }

      .con-input-upload {
        margin: 0;
      }


      &_danger {
        .con-input-upload {
          border: 1px dashed rgba(var(--app-danger), 1);
        }

        .employee-debtors-sms__file-error {
          display: block;
        }
      }

      &-error {
        display: none;
        color: rgba(var(--app-danger), 1);
        transition: all .25s ease;
        margin-top: 3px;
        font-weight: 600;
        text-transform: uppercase;
        padding: 4px;
        line-height: 1.2;
        font-size: .71rem;
        text-align: center;
      }
    }

    &__row {
      margin-bottom: 15px;

      &_center {
        text-align: center;
      }
    }
  }

  .employee-debtors-sms-view{
    display: flex;
    margin: -15px;
    flex-wrap: wrap;

    &__col{
      flex: 1;
      padding: 15px;
      width: 50%;

      @media (max-width: 1200px) {
        width: 100%;
        flex: 0 1 100%;
      }
    }
  }
</style>
